import * as e from "react";
const a = (t) => /* @__PURE__ */ e.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 21 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ e.createElement("rect", { x: 0.5, y: 0.5, width: 19.4, height: 16, rx: 1.2, stroke: "#8C8C8C" }), /* @__PURE__ */ e.createElement("path", { d: "M0.0356445 7H20.0356M4.03564 11H16.0356", stroke: "#8C8C8C" }));
export {
  a as default
};
